// extracted by mini-css-extract-plugin
export default {"detailPageCard":"styles_detailPageCard__NqfxZ"};